import { render, staticRenderFns } from "./DayWeekCalendarItem.vue?vue&type=template&id=dd140c9a&scoped=true"
import script from "./DayWeekCalendarItem.vue?vue&type=script&lang=js"
export * from "./DayWeekCalendarItem.vue?vue&type=script&lang=js"
import style0 from "./DayWeekCalendarItem.vue?vue&type=style&index=0&id=dd140c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd140c9a",
  null
  
)

export default component.exports